// import { Link as StyledLink } from 'react-router-dom';
import { Boundary, Menu, MenuItem, Position, Tag } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import StyledLink from "components/Atoms/StyledLink"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import React from "react"

const renderVisible = (item, index) => {
  return (
    <StyledLink
      key={item.id ? item.id : index}
      to={`/d/registration/plot/${item.id}`}
      className="ml-2"
      text={false}
    >
      <Tag round={true} interactive={true} intent="none" minimal={true}>
        {item.codename}
      </Tag>
    </StyledLink>
  )
}
const renderOverflow = items => {
  return (
    <CustomPopover
      position={Position.BOTTOM}
      content={
        <Menu className="vt-plot-list-menu">
          {items.map(item => (
            <StyledLink
              key={item.id}
              to={`/d/registration/plot/${item.id}`}
              text={false}
            >
              <MenuItem
                tagName="span"
                icon="polygon-filter"
                text={item.codename}
              />
            </StyledLink>
          ))}
        </Menu>
      }
    >
      <Tag round={true} className="ml-2" interactive={true}>
        + {items.length}
      </Tag>
    </CustomPopover>
  )
}
const FarmerPlotList = ({ plots }) => {
  return (
    <CustomOverflowList
      items={plots}
      overflowRenderer={renderOverflow}
      visibleItemRenderer={renderVisible}
      collapseFrom={Boundary.END}
    ></CustomOverflowList>
  )
}

export default FarmerPlotList
